import Glide from '@glidejs/glide';

const glides = document.querySelectorAll('[data-behaviour="slider"]');

if (glides.length > 0) {
    glides.forEach((glide) => {
        const glideInstance = new Glide(glide, {
            type: glide.dataset.type ? glide.dataset.type : 'slider',
            bound: glide.dataset.bound ? glide.dataset.bound : 0,
            rewind: glide.dataset.rewind ? glide.dataset.rewind : 0,
            gap: glide.dataset.gap ? glide.dataset.gap : 0,
            autoplay: glide.dataset.autoplay ? glide.dataset.autoplay : 0,
            hoverpause: glide.dataset.hoverpause ? glide.dataset.hoverpause : 0,
            animationDuration: 400,
            animationTimingFunc: 'ease-in-out',
            perView: glide.dataset.itemsDesktop
                ? glide.dataset.itemsDesktop
                : 1,
            breakpoints: {
                600: {
                    perView: glide.dataset.itemsMobile
                        ? glide.dataset.itemsMobile
                        : 1,
                    peek: {
                        before: glide.dataset.peekBefore
                            ? glide.dataset.peekBefore
                            : 0,
                        after: glide.dataset.peekAfter
                            ? glide.dataset.peekAfter
                            : 0,
                    },
                },
                940: {
                    perView: glide.dataset.itemsTablet
                        ? glide.dataset.itemsTablet
                        : 1,
                },
                1040: {
                    perView: glide.dataset.itemsDesktop
                        ? glide.dataset.itemsDesktop
                        : 1,
                },
            },
        });

        // Mount first
        glideInstance.mount();

        if (glideInstance.settings.type === 'carousel') return;

        // Height calculation function
        function glideHandleHeight() {
            const activeSlide = glide.querySelector('.glide__slide--active');
            if (!activeSlide) return;

            const glideTrack = glide.querySelector('.glide__track');
            if (!glideTrack) return;

            // Find all images in the active slide (multiple selectors for different contexts)
            const images = activeSlide.querySelectorAll(
                'img, .slider__main-image__image img, picture img',
            );

            // Find iframes for video content
            const iframes = activeSlide.querySelectorAll('iframe');

            let loadedImages = 0;
            const totalImages = images.length;

            function setHeight() {
                let maxHeight = 0;

                // Check all images in the active slide
                images.forEach((img) => {
                    if (img.offsetHeight > maxHeight) {
                        maxHeight = img.offsetHeight;
                    }
                });

                // Check iframes for video content
                iframes.forEach((iframe) => {
                    if (iframe.offsetHeight > 0) {
                        if (iframe.offsetHeight > maxHeight) {
                            maxHeight = iframe.offsetHeight;
                        }
                    } else {
                        // Calculate 16:9 aspect ratio for videos if no height set
                        const width =
                            iframe.offsetWidth || activeSlide.offsetWidth;
                        const calculatedHeight = width * (9 / 16);
                        if (calculatedHeight > maxHeight) {
                            maxHeight = calculatedHeight;
                        }
                    }
                });

                // If no image or iframe height found, try getting height from containers
                if (maxHeight === 0) {
                    const imageContainers = activeSlide.querySelectorAll(
                        '.slider__image-container, .card__media, .video-block',
                    );
                    imageContainers.forEach((container) => {
                        if (container.offsetHeight > maxHeight) {
                            maxHeight = container.offsetHeight;
                        }
                    });
                }

                // Final fallback to slide height
                if (maxHeight === 0) {
                    maxHeight = activeSlide.offsetHeight;
                }

                if (maxHeight > 0) {
                    glideTrack.style.height = `${maxHeight}px`;
                    // Also set height on the main slider container for absolute positioned elements
                    glide.style.height = `${maxHeight}px`;
                }
            }

            // If we have iframes or no images, set height immediately
            if (totalImages === 0 || iframes.length > 0) {
                setTimeout(setHeight, 50);
            } else {
                // Wait for all images to load
                images.forEach((img) => {
                    if (img.complete && img.naturalHeight > 0) {
                        loadedImages++;
                        if (loadedImages === totalImages) {
                            setTimeout(setHeight, 50);
                        }
                    } else {
                        const onLoad = () => {
                            loadedImages++;
                            if (loadedImages === totalImages) {
                                setTimeout(setHeight, 50);
                            }
                            img.removeEventListener('load', onLoad);
                            img.removeEventListener('error', onLoad);
                        };
                        img.addEventListener('load', onLoad);
                        img.addEventListener('error', onLoad);
                    }
                });
            }
        }

        // Initial height calculation after mount
        setTimeout(glideHandleHeight, 200);

        // Height calculation on slide change
        glideInstance.on('run.after', function () {
            setTimeout(glideHandleHeight, 100);
        });

        // Recalculate on window resize
        window.addEventListener('resize', function () {
            setTimeout(glideHandleHeight, 100);
        });
    });
}
